<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="고객사 결제 내역 확인" :IsUseEditorBox="true" device="web">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                class="mx-1"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'start')"
                :allowMaxDate="minDate"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                class="mx-1"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'end')"
                :allowMinDate="minDate"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="contractApprovalManageDataGrid"
                  class="layout-col-height00"
                  style="width: 100%; height: 100%"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  :selection="{ mode: 'single' }"
                  key-expr="orderId"
                  @editing-start="onEditingStart"
                  @editor-preparing="onEditorPreparing"
                >
                  <DxColumn data-field="clntNm" data-type="string" alignment="center" width="200px" caption="고객사명" :allow-editing="false" />
                  <DxColumn
                    data-field="compNm"
                    data-type="string"
                    alignment="center"
                    width="240px"
                    caption="적용 사업장(공사)"
                    :allow-editing="false"
                  />
                  <DxColumn data-field="feeName" data-type="string" alignment="center" width="200px" caption="항목" :allow-editing="false" />
                  <DxColumn data-field="paymentStatusNm" data-type="string" alignment="center" caption="상태" width="120px" :allow-editing="false" />
                  <DxColumn
                    data-field="paymentAmount"
                    data-type="string"
                    alignment="right"
                    width="200px"
                    caption="결제 금액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <template #amountCellTemplate="{ data: cellInfo }">
                    <div>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
                  </template>
                  />
                  <DxColumn data-field="orderId" data-type="string" alignment="center" width="300px" caption="주문번호" :allow-editing="false" />
                  <DxColumn data-field="paymentDt" data-type="string" alignment="center" width="250px" caption="결제일시" :allow-editing="false" />
                  <DxColumn
                    data-field="paymentMethod"
                    data-type="string"
                    alignment="center"
                    width="150px"
                    caption="결제수단"
                    :allow-editing="false"
                  />
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)">
        <template v-slot:body>
          <v-layout>
            <v-row no-gutters class="pa-0 pt-2">
              <v-col cols="12" md="4"></v-col>
            </v-row>
          </v-layout>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import { getClientPaymentHistoryList } from '@/payment/api/clientPaymentHistory'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

import { getPaymentHistory } from '@/api/sojunganManagement/paymentHistory.js'
export default {
  mixins: [baseview, BaseDataGrid],
  name: 'ClientPaymentHistory',
  components: {
    IDateTimePicker,
  },
  data() {
    return {
      dxDataGridRef: 'clientPaymentHistoryDataGrid',
      buttonUseList: [
        'btnSearch', // 조회
      ],
      gridMain: [],
      startDate: getPreMonth(12),
      endDate: getPreMonth(0),
      searchStartDate: getPreMonth(12).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(0).replace(/[^0-9]/g, ''),
      searchMinDate: getCurrentDate(),
      searchMaxDate: getPreMonth(12),
      minDate: getCurrentDate(-2),
    }
  },
  computed: {},
  beforeMount() {},
  activated() {},
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    formatToKoreanWon(value) {
      const numberValue = parseFloat(value.replace(/,/g, ''))
      if (!isNaN(numberValue)) {
        return numberValue.toLocaleString('ko-KR')
      }
    },
    //------------------------------------------
    //  검색 년월일 포맷
    //------------------------------------------
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
    },
    //------------------------------------------
    //  고객사 결제 내역 확인 조회
    //------------------------------------------
    async btnSearch(isNotify) {
      let params = {
        searchStartDate: this.searchStartDate,
        searchEndDate: this.searchEndDate,
      }
      this.openLoading()
      getPaymentHistory(params, isNotify)
        .then((res) => {
          if (res.success) {
            this.gridMain = res.list
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // //------------------------------------------
    // //  세금계산서 발행 버튼 클릭
    // //------------------------------------------
    // async btnIssuance(cellInfo) {
    //   console.log('@@ cellInfo', cellInfo)
    //   this.vToastifyPrompt(
    //     this.$t(`고객사: ${cellInfo.data.clntNm} <br/> 주문번호: ${cellInfo.data.orderId} <br/>  세금계산서 발행페이지로 이동하시겠습니까?`),
    //     'info',
    //     current => {
    //       const toRouter = {
    //         name: 'ClientPaymentHistoryDetail',
    //         params: {
    //           data: cellInfo.data
    //         }
    //       }
    //       this.$router.push(toRouter)
    //     },
    //     null,
    //     true
    //   )
    // },
    //------------------------------------------
    //  날짜 포맷
    //------------------------------------------
    formatDate(date) {
      const year = date.substring(0, 4)
      const month = date.substring(4, 6)
      const day = date.substring(6, 8)
      return `${year}-${month}-${day}`
    },
  },
}
</script>

<style scoped></style>
